
<template>
  <div>
    <div id="map" style="width: 100%; height: 700px"></div>
  </div>
</template>

<script >
export default {
  props: ["site", "zone", "pvfields", "token"],

  data: function () {
    return {
      map: {},
      type: "",
      id: "",
      draw: {},
      isRoof: 1,
      isComplete: 1,
      build: {},
      pvfieldList: [],
      buildingList: [],
      param: {},
      capex: {},
      opex: {},
      country: "",
      roof: {},
      clickLong:0,
      clickArea:0,
      clickMesure:0,
      pointMesure:[],
      fixePoint:[],
      flightPath:{},
      mouvePoint:{},
      firstPoint:{},
    };
  },
  mounted: function () {
    const token = this.token;
    const GoogleMap = require("@googlemaps/js-api-loader");

    const loader = new GoogleMap.Loader({
      apiKey: token,
      version: "weekly",
      libraries: ['geometry','marker']
    });
    
    var color = [
      "#FF5DCC",
      "#18FE01",
      "#FE8D00",
      "#FFD700",
      "#00CDFF",
      "#FF06AE",
      "#14BE01",
      "#BF6900",
      "#BFA300",
      "#0099BF",
      "#AE0076",
      "#0D8000",
      "#804600",
      "#806C00",
      "#006680",
    ];

    var nbColor = color.length;

    var nbArray = Math.floor(this.zone.length / nbColor) + 1;
    var temp = [];

    for (let j = 0; j < nbArray; j++) {
      temp = temp.concat(color);
    }

    color = temp;

    var i = 0;

    var data = [];

    this.zone.forEach((element) => {
      if(element.a_prendre==1){
        var building = {
          strokeColor: "color : " + color[i],
        };

        if (this.pvfields != []) {
          if (this.pvfields[element.id].length > 0) {
            var data3 = {
              type: "FeatureCollection",
              features: [],
            };

            this.pvfields[element.id].forEach((element) => {
              var data2 = JSON.parse(element.affichage).champ.features;

              data2.forEach((element) => {
                element.properties.id = "PV" + i;
                element.properties.dataSetId = i;
                data3.features.push(element);
              });
            });
            data[i] = data3;
          }
        }
        i++;
        this.buildingList.push(building);
      }
    });

    var pvtable = this.pvfields;
    var tempLatitude = 0;
    var tempLongitude = 0;
    var zoomRapport = 19;
    /*if(this.site.imageplan) {
      tempLatitude = this.site.imageplan.latitude;
      tempLongitude = this.site.imageplan.longitude;
      zoomRapport = this.site.imageplan.zoom;
    } else */
    if (this.zone.length == 0) {
      tempLatitude = this.site.latitude;
      tempLongitude = this.site.longitude;
    } else {
      var i = 0;

      this.zone.forEach((element) => {
        tempLatitude = element.latitude + tempLatitude;
        tempLongitude = element.longitude + tempLongitude;
        i++;
      });
      tempLatitude = tempLatitude / i;
      tempLongitude = tempLongitude / i;

      var distance = -1;

      this.zone.forEach((element) => {
        var temp = turf.distance(
          turf.point([tempLongitude, tempLatitude]),
          turf.point([element.longitude, element.latitude])
        );
        if (temp > distance) {
          distance = temp * 3;
        }
      });

      var div = document.getElementById("map");

      var rapport = (distance * 1000) / div.clientWidth;

      if (rapport < 0.019) {
        zoomRapport = 22;
      } else if (rapport < 0.037) {
        zoomRapport = 21;
      } else if (rapport < 0.075) {
        zoomRapport = 20;
      } else if (rapport < 0.149) {
        zoomRapport = 19;
      } else if (rapport < 0.299) {
        zoomRapport = 18;
      } else if (rapport < 0.597) {
        zoomRapport = 17;
      } else if (rapport < 1.194) {
        zoomRapport = 16;
      } else if (rapport < 2.389) {
        zoomRapport = 15;
      } else if (rapport < 4.777) {
        zoomRapport = 14;
      } else if (rapport < 9.555) {
        zoomRapport = 13;
      } else if (rapport < 19.102) {
        zoomRapport = 12;
      } else if (rapport < 38.218) {
        zoomRapport = 11;
      } else if (rapport < 76.437) {
        zoomRapport = 10;
      } else if (rapport < 152.874) {
        zoomRapport = 9;
      } else if (rapport < 305.748) {
        zoomRapport = 8;
      } else if (rapport < 611.496) {
        zoomRapport = 7;
      } else if (rapport < 1222.992) {
        zoomRapport = 6;
      } else if (rapport < 2445.984) {
        zoomRapport = 5;
      } else if (rapport < 4891.968) {
        zoomRapport = 4;
      } else if (rapport < 9783.936) {
        zoomRapport = 3;
      } else {
        zoomRapport = 2;
      }
      zoomRapport--;
    }

    loader.load().then(() => {
      const map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: tempLatitude, lng: tempLongitude },
        mapTypeControl: false,
        zoom: zoomRapport,
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        streetViewControl: false,
        heading: 0,
        tilt: 0,
        mapId: "90f87356969d889c", // Map ID is required for advanced markers.
      });


      map.addListener("click", (e) => {
        this.saveMap();
      });
      // le listener idle est appelé en fin de mouvement (drag, zoom)
      map.addListener("idle", (e) => {
        this.saveMap();
      });

      if(this.site.imageplan) {
        var imageplan = this.site.imageplan;
        const ImagePlanOverlay = require("./maps/imagePlanOverlay.js");
        const sw = JSON.parse(this.site.imageplan.southwest);
        const ne = JSON.parse(this.site.imageplan.northeast);
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(sw.lat, sw.lng),
          new google.maps.LatLng(ne.lat, ne.lng)
        );
        this.overlay = new ImagePlanOverlay.default(bounds, imageplan.image, imageplan.rotationAngle);

        this.overlay.setMap(map);
      }

      google.maps.event.addListenerOnce(map, 'tilesloaded', (e) => {
          this.saveMap();
      });
      
      const { getCadastreLayer, getPLULayer, getOverlayControls } = require("./maps/additional-layers.js");
      const { EnedisHTLines, EnedisBTLines, EnedisDeliveryPosts, RteLines, RtePylones, RtePostes } = require("./maps/opendata-carto-module.js");

      const overlaysMenu = getOverlayControls({
        'cadastre': getCadastreLayer(),
        'urbanism': getPLULayer(map),
        'ht-lines': new EnedisHTLines(this.site.longitude, this.site.latitude, 1),
        'bt-lines': new EnedisBTLines(this.site.longitude, this.site.latitude, 1),
        'posts': new EnedisDeliveryPosts(this.site.longitude, this.site.latitude, 1),
        //'rte-posts': new RtePostes(this.site.longitude, this.site.latitude, 5),
        //'rte-lines': new RteLines(this.site.longitude, this.site.latitude, 5),
        //'rte-pylones': new RtePylones(this.site.longitude, this.site.latitude, 5),
      }, map);
      
      const menu = document.createElement("div");
      menu.className = "menu menu-right";

      const Regle = require("./maps/regle.js");
      const menuRegle = new Regle.default(map);
      menu.appendChild(menuRegle.getItemMenu());

      const Surface = require("./maps/surface.js");
      const menuSurface = new Surface.default(map);
      menu.appendChild(menuSurface.getItemMenu());
      
      map.controls[google.maps.ControlPosition.LEFT_TOP].push(menu);
      map.controls[google.maps.ControlPosition.LEFT_TOP].push(overlaysMenu);
      
      var HTMLMarker = require("./maps/HTMLMarker.js");

      this.zone.forEach((element) => {
        var div = document.createElement("div");
        div.className = "circleMarker";
        var text = document.createElement("h6");
        text.className = "text-center";
        if (element.nom != null) {
          var temp = element.nom;
        }
        text.textContent = temp;
        div.appendChild(text);

        var marker = new HTMLMarker.default(element.latitude, element.longitude, element.nom.substr(element.nom.indexOf(" ")+1), element.nom);
        marker.setMap(map);

        var listBuilding = Object.keys(pvtable);
        let i = 0;
        listBuilding.forEach((elementbuilding) => {
          if (elementbuilding) {
            if (pvtable[elementbuilding].length >= 1) {
              map.data.addGeoJson(data[i]);
              map.data.setStyle((feature) => {
                let entries = Object.values(feature);
                var res = {};
                entries.forEach((val) => {
                  if(val && val.dataSetId !== undefined) {
                    res = {
                      fillColor: color[val.dataSetId],
                      fillOpacity: 0.6,
                      strokeWeight: 0,
                    };
                    return; // return pour ne pas itérer inutilement usr les props restantes
                  }
                });
                return res;
              });
            }
          }
          i++;
        });

      });

    });
    this.saveMap();
  },

  methods: {
    saveMap() {
      const html2canvas = require("html2canvas");

      html2canvas(document.getElementById("map"), {
        useCORS: true,
        logging: false
      }).then(function (canvas) {
          let value = JSON.stringify(canvas.toDataURL("image/jpeg"));
          $("input[id^='imgSite']").val(value);
        });
    },

  },
};
</script>
